import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  rsActiveMenu,
  rsParentCom,
  rsProgress,
} from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterCommunications } from "./UseFooterCommunications";
import { useNavigate } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomPagination from "../../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../../components/DeleteRow";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function FooterCommunications(props) {
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooterCommunications, RemoveFooterCommunications } =
    UseFooterCommunications();
  const [communicationsRes, setCommunicationsRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );

  useEffect(() => {
    if (props.expanded === "panel5") {
      setProgress(true);
      GetFooterCommunications(
        homePageId?.id ? homePageId.id : 1,
        (Communications) => {
          setCommunicationsRes(Communications);
        }
      );
    }
  }, [props.expanded, homePageId]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("panel5");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (props.expanded === "panel5") {
      const element = document.getElementById("panel5");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [props.expanded]);

  const newFunc = () => {
    return navigate("/footerManage/addCommunication", {
      state: {
        model: communicationsRes ? communicationsRes : [],
        expanded: props.expanded,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "title",
      width: 350,
      align: "center",
      headerName: "عنوان",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "visible",
      width: 120,
      align: "center",
      headerName: "نمایش",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.visible ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 130,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  navigate("/footerManage/editCommunication", {
                    state: {
                      model: cellValues.row,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Accordion
      expanded={props.expanded === "panel5"}
      id="panel5"
      onChange={handleChange("panel5")}
      style={{ marginTop: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel5")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel5bh-content"
        id="panel5bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            اطلاعات ارتباط با کاربر
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "30rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={100}
            rows={communicationsRes ? communicationsRes : []}
            rowCount={communicationsRes?.length ? communicationsRes.length : 1}
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                newFunc: newFunc,
                isLtr: true,
                rowCount: communicationsRes?.length
                  ? communicationsRes.length
                  : "",
              },
            }}
          />
        </Box>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={""}
          callback={() => {
            setProgress(true);
            RemoveFooterCommunications(deleteState.id, () => {
              GetFooterCommunications(
                homePageId?.id ? homePageId.id : 1,
                (Communications) => {
                  setCommunicationsRes(Communications);
                }
              );
            });
          }}
        ></DeleteRow>
      </AccordionDetails>
    </Accordion>
  );
}
